import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconStopWatch: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5979 7.96301L18.531 7.03003C18.824 6.73703 18.824 6.26199 18.531 5.96899C18.238 5.67599 17.763 5.67599 17.47 5.96899L16.4919 6.94702C15.1039 5.88702 13.377 5.25 11.5 5.25C6.951 5.25 3.25 8.951 3.25 13.5C3.25 18.049 6.951 21.75 11.5 21.75C16.049 21.75 19.75 18.049 19.75 13.5C19.75 11.368 18.9299 9.42901 17.5979 7.96301ZM11.5 20.25C7.778 20.25 4.75 17.222 4.75 13.5C4.75 9.778 7.778 6.75 11.5 6.75C15.222 6.75 18.25 9.778 18.25 13.5C18.25 17.222 15.222 20.25 11.5 20.25ZM13.95 14.4C14.281 14.649 14.3481 15.119 14.0991 15.45C13.9531 15.646 13.727 15.75 13.498 15.75C13.342 15.75 13.1841 15.701 13.0491 15.6L11.0491 14.1C10.8611 13.958 10.749 13.736 10.749 13.5V10C10.749 9.586 11.085 9.25 11.499 9.25C11.913 9.25 12.249 9.586 12.249 10V13.125L13.95 14.4ZM8.25 3C8.25 2.586 8.586 2.25 9 2.25H14C14.414 2.25 14.75 2.586 14.75 3C14.75 3.414 14.414 3.75 14 3.75H9C8.586 3.75 8.25 3.414 8.25 3Z"
      fill={color}
    />
  </svg>
);

export default IconStopWatch;
